import React from 'react'
import { EmailTypeInputParametersHierarchyConfigComponentProps } from '../model'
import { useEmailTypeEffectiveInputParameters } from '../hooks'
import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'
import { MeetingTemplateGlobalTemplateConfigFormBody } from './MeetingTemplateGlobalTemplateConfigFormBody'

export const EmailTypeGlobalTemplateInputParameterConfigForm: React.FC<EmailTypeInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  onHide,
  inputParametersSchema,
  defaultInputParameters,
  emailTypeId,
  showCustomizationSetting,
  ipHierarchyEnabled,
}) => {
  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useEmailTypeEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    undefined,
    emailTypeId,
  )

  if (!inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  return (
    <MeetingTemplateGlobalTemplateConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
